import { Component, OnDestroy } from '@angular/core'
import { PendingState } from '../account/account.root.state'
import { Store } from '@ngrx/store'
import { Observable, of, tap } from 'rxjs'
import { selectElementsState, selectOrderPendingState } from '../orders/orders.root.state'
import { Subscriptions } from '../utils/subscriptions'
import { ApiService } from '@api/api.service'
import { catchError, first } from 'rxjs/operators'
import { Release } from '@api/models/CustomerInfoCall'

@Component({
  selector: 'cover-digital-subscription-content',
  templateUrl: './digital-subscription-content.component.html',
  styleUrls: ['./digital-subscription-content.component.scss'],
})
export class DigitalSubscriptionContentComponent implements OnDestroy {
  private readonly subscriptions: Subscriptions = new Subscriptions(true)
  customerPendingState$: Observable<PendingState>
  releases: Release[] = []
  lockedElements: Release[] = []
  noReleases: boolean = false

  constructor(private readonly store: Store, private readonly api: ApiService) {
    this.customerPendingState$ = this.store.select(selectOrderPendingState)
    this.subscriptions.plusOne = this.store
      .select(selectElementsState)
      .pipe(
        tap(orderDataState => {
          this.releases = []
          const parseDate = (d: string): number => {
            const [dd, mm, yyyy] = d.split('.')
            return new Date(+yyyy, +mm - 1, +dd).getTime()
          }
          ;[...orderDataState.element]
            .sort((a, b) => parseDate(a.startDate) - parseDate(b.startDate))
            .forEach(orderElement => {
              orderElement.releases.forEach(release => {
                if (
                  !this.releases.some(existingRelease => {
                    return (
                      existingRelease.article_nr === release.article_nr &&
                      existingRelease.attribute_name === release.attribute_name &&
                      existingRelease.download_url === release.download_url
                    )
                  })
                ) {
                  this.releases.push(release)
                }
              })
            })
          this.noReleases = this.releases.length === 0
        }),
      )
      .subscribe()
  }

  readonly pendingState = PendingState

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
  }

  download(release: Release): void {
    this.lockedElements.push(release)
    this.api
      .downloadArticle(release.download_url)
      .pipe(
        first(),
        tap(_ => {
          this.lockedElements = this.lockedElements.filter(element => element !== release)
        }),
        catchError(error => {
          this.lockedElements = this.lockedElements.filter(element => element !== release)
          return of(error)
        }),
      )
      .subscribe()
  }

  equalsFirst(element: Release): boolean {
    return JSON.stringify(element) === JSON.stringify(this.releases[this.releases.length - 1])
  }
}
